import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { ref, onValue } from "firebase/database";
import { useNavigate } from "react-router-dom";
import { db } from "../services/firebase";
import "./ViewResults.css";

const ViewResults = () => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();
  const user = auth.currentUser;
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;

    const lightMode = localStorage.getItem("theme") === "light";
    document.body.classList.toggle("light", lightMode);

    const darkMode = localStorage.getItem("theme") === "dark";
    document.body.classList.toggle("dark", darkMode);

    // Fetch all results from the results path
    const resultsRef = ref(db, "results/");
    
    onValue(resultsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const allResults = Object.entries(data)
          .map(([id, value]) => ({ id, ...value }))
          .filter((item) => item.user === user.email);

        allResults.sort(
          (a, b) =>
            new Date(b.submittedAt || b.date) - new Date(a.submittedAt || a.date)
        );
        setResults(allResults);
      } else {
        setResults([]);
      }
      setLoading(false);
    });
  }, [user]);

  const viewDetailedResult = (result) => {
    if (result.testType === "coding") {
      localStorage.setItem("latestCodingResult", JSON.stringify(result));
      navigate("/coding-result");
    } else if (result.testType === "codeSnippet") {
      localStorage.setItem("latestCodeSnippetResult", JSON.stringify(result));
      navigate("/code-snippet-result");
    } else {
      localStorage.setItem("latestMCQResult", JSON.stringify(result));
      navigate("/mcq-result");
    }
  };

  if (!user) return <p>Please log in to view your results.</p>;

  return (
    <div className="results-container">
      <h2>📊 Your Test Results</h2>

      {loading ? (
        <p>Loading...</p>
      ) : results.length === 0 ? (
        <p>No results found.</p>
      ) : (
        <table className="results-table">
          <thead>
           
            
            <tr style={{ backgroundColor: "#ffcba2ff" }}>
              <th style={cellStyle}>#</th>
              <th style={cellStyle}>Date</th>
              <th style={cellStyle}>Quiz</th>
              <th style={cellStyle}>Topic</th>
              <th style={cellStyle}>Score</th>
              <th style={cellStyle}>Accuracy</th>
              <th style={cellStyle}>Type</th>
              <th style={cellStyle}>Action</th>
            </tr>
          </thead>
          <tbody>
            {results.map((res, index) => (
              <tr key={res.id} style={{ borderBottom: "1px solid #ddd" }}>
                <td style={cellStyle}>{index + 1}</td>
                <td style={cellStyle}>
                  {new Date(res.submittedAt || res.date).toLocaleString("en-IN", {
                    dateStyle: "medium",
                    timeStyle: "short",
                  })}
                </td>
                <td style={cellStyle}>{res.quizTitle || "N/A"}</td>
                <td style={cellStyle}>{res.topic || "-"}</td>
                <td style={cellStyle}>{res.score}</td>
                <td style={cellStyle}>{res.accuracy ?? "--"}%</td>
                <td style={cellStyle}>
                  <span
                    className={`badge ${
                      res.testType === "coding" ? "badge-coding" : 
                      res.testType === "codeSnippet" ? "badge-codeSnippet" : 
                      "badge-mcq"
                    }`}
                  >
                    {res.testType === "codeSnippet" ? "CODE SNIPPET" : 
                     res.testType?.toUpperCase() || "MCQ"}
                  </span>
                </td>
                <td style={cellStyle}>
                  <button
                    className="view-button"
                    onClick={() => viewDetailedResult(res)}
                  >
                    🔍 View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

const cellStyle = {
  padding: "10px",
  textAlign: "center",
};

export default ViewResults;
